import { FC, ReactNode, useEffect, useRef, useState } from 'react';

import { useMedia } from '../../hooks/useMedia';
import { Button, ButtonVariant } from '../controls/button/Button';
import { Swiper, SwiperHandle } from '../swiper/Swiper';

import styles from './QuickGuide.module.css';

export interface QuickGuidePlainProps {
  isOpen: boolean;
  listItems: ReactNode[];
  onPlayAction: () => void;
}

export const QuickGuidePlain: FC<QuickGuidePlainProps> = ({ isOpen, listItems, onPlayAction }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const horizontalScrollRef = useRef<SwiperHandle>(null);

  const smallHeight = useMedia(`(max-height: 340px)`);

  useEffect(() => {
    if (isOpen) {
      setActiveIndex(0);
    }
  }, [isOpen]);
  const containerRef = useRef<HTMLDivElement>(null);

  const handlePrevious = (): void => {
    horizontalScrollRef.current?.goTo('previous');
  };

  const handleNext = (): void => {
    horizontalScrollRef.current?.goTo('next');
  };

  return (
    <div ref={containerRef} className={styles.quickGuide}>
      <div className={styles.quickGuideSliderWrapper}>
        <Swiper
          className={styles.quickGuideSlider}
          ref={horizontalScrollRef}
          onActiveChange={(index) => setActiveIndex(index)}
          dots={!smallHeight && listItems.length > 1}
        >
          {listItems}
        </Swiper>
      </div>
      <div className={styles.quickGuide__footer}>
        {listItems.length === 1 ? (
          <Button variant={ButtonVariant.ACCENT} onClick={onPlayAction} tk="PLAY" />
        ) : (
          <>
            <Button variant={ButtonVariant.MAIN} disabled={activeIndex === 0} onClick={handlePrevious} tk="PREVIOUS" />
            {smallHeight ? (
              <span className={styles.quickGuideSlideCounter}>
                {activeIndex + 1}/{listItems.length}
              </span>
            ) : null}
            {activeIndex === listItems.length - 1 ? (
              <Button variant={ButtonVariant.ACCENT} onClick={onPlayAction} tk="PLAY" />
            ) : (
              <Button
                data-testid="quick-guide-next-button"
                variant={ButtonVariant.ACCENT}
                onClick={handleNext}
                tk="NEXT"
              />
            )}
          </>
        )}
      </div>
    </div>
  );
};
